import API from 'mixins/api';

let idleJs = require('idle-js');
export const analytics = {
  mixins: [API],
  data() {
    return {
      analytics: {},
      analyticsTimer: null,
      analyticsIdle: null
    }
  },
  mounted() {
    this.analytics.time = 0;
    this.startTimer();

    // Send the analytics payload
    window.onbeforeunload = this.stopAnalytics;

    window.Events.$on('documentSigned', () => {
      this.analytics.action = 'signed';
    });
    window.Events.$on('documentDownloaded', () => {
      this.analytics.action = 'downloaded';
    });

    // IdleJs watcher
    this.analyticsIdle = new idleJs({
      idle: 5000,
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
      onIdle: this.stopTimer,
      onActive: this.startTimer,
      onHide: this.stopTimer,
      onShow: this.startTimer,
      keepTracking: true,
      startAtIdle: false
    }).start();
  },
  methods: {
    startTimer() {
      this.analyticsTimer = setInterval(() => {
        ++this.analytics.time;
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.analyticsTimer);
    },
    startAnalytics(data) {
      this.analytics.document_id = data.document.id;
      this.analytics.document_uuid = data.document.uuid;
      this.analytics.viewer_id = data.recipient.id;
      this.analytics.viewer_type = data.recipient.hasOwnProperty('company') ? "App\\Contact" : "App\\User"; // Only Contacts have a property
      this.analytics.action = 'viewed';
    },
    stopAnalytics(event) {
      this.analytics.section = 'TBD';
      this.api().createAnalytics(this.$route.params.guid, this.analytics);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/analytics.js